import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";

// Premium overshoot. Lots of pre-rolled animation pros teach this exact
// keyframe shape: tiny pre-frame at 96%, snap past 100%, settle to 100%.
// The trick is the 105% peak (not 115% — that reads as a cartoon, not a brand).
export const scalePop: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeOutBack",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, scale: 0.40, filter: "blur(2px)" },
        { t: 0.55, opacity: 1, scale: 1.06, filter: "blur(0px)" },
        { t: 0.78, scale: 0.985 },
        { t: 1.00, scale: 1 },
      ],
    }],
  };
};
